import styled from 'styled-components';
// import palette from '../../../lib/styles/palette';

import { Wrapper, Label, Variable, InputBlock, StyledInput, StyledOutput, StyledSelect, Unit } from './SingleInput';
import { formatDisplayValue } from '../../../lib/styles/perttierNumber';

/* Multi Input 컴포넌트 */
export const MultiInput = ({
    label,
    variable,
    variableName,
    unit,
    values,
    min = '0',
    referenceValues,
    onChange,
    isRequired,
    isText = false,
    ...props
}) => {
    const indexMap = {
        0: '1st',
        1: '2nd',
        2: '3rd',
    };

    return (
        <Wrapper>
            <Label>{label}</Label>
            <Variable>{variable}</Variable>
            <InputBlock>
                {values.map((value, index) => (
                    <StyledInput
                        key={index}
                        name={`${indexMap[index]}_${variableName}`}
                        value={value}
                        onChange={(e) => {
                            if (isText) {
                                onChange(e);
                            } else {
                                const newValue = e.target.value;
                                // 숫자가 아니거나 'min'보다 작으면 실행하지 않음
                                if (newValue === '' || Number(newValue) >= Number(min)) {
                                    onChange(e);
                                }
                            }
                        }}
                        placeholder={referenceValues?.[index] ?? ''}
                        {...props}
                    />
                ))}
            </InputBlock>
            <Unit>{unit}</Unit>
        </Wrapper>
    );
};

/* Multi Output 컴포넌트 */
export const MultiOutput = ({ label, variable, unit, values, isSub, isSafeArray }) => {
    return (
        <Wrapper isSub={isSub}>
            <Label>{label}</Label>
            <Variable>{variable}</Variable>
            <InputBlock>
                {values.map((value, index) => (
                    <StyledOutput key={index} value={formatDisplayValue(value)} disabled isSub={isSub} isSafe={isSafeArray?.[index] ?? true} />
                ))}
            </InputBlock>
            <Unit>{unit}</Unit>
        </Wrapper>
    );
};

/* Multi Select 컴포넌트 */
export const MultiSelect = ({ label, variable, variableName, unit, values, options, onChange, isRequired }) => {
    const indexMap = {
        0: '1st',
        1: '2nd',
        2: '3rd',
    }
    return (
        <Wrapper>
            <Label>{label}</Label>
            <Variable>{variable}</Variable>
            <InputBlock>
            {values.map((value, index) => (
                <StyledSelect key={index} name={`${indexMap[index]}_${variableName}`} value={value} onChange={onChange} isRequired={isRequired} >
                    <option value="" selected disabled hidden>
                        Select...
                    </option>
                    {options.map((item, index) => (
                        <option key={index} value={item.value}>{item.text}</option>
                    ))}
                </StyledSelect>
            ))}
            </InputBlock>
            <Unit>{unit}</Unit>
        </Wrapper>
    );
};

/* Error Message */
const ErrorMessage = styled(StyledOutput)`
    color: red;
`;
export const MultiErrorMessage = ({ label, variable, unit, values }) => {
    return (
        <Wrapper>
            <Label>{label}</Label>
            <Variable>{variable}</Variable>
            <InputBlock>
                {values.map((value, index) => (
                    <ErrorMessage key={index} value={formatDisplayValue(value)} disabled />
                ))}
            </InputBlock>
            <Unit>{unit}</Unit>
        </Wrapper>
    );
};
